import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpUrlEncodingCodec, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { CryptoService } from './crypto.service';

class Base64Encoder extends HttpUrlEncodingCodec {
  encodeValue(value: string): string {
    return encodeURIComponent(value);
  }
}

@Injectable()
export class CryptoInterceptor implements HttpInterceptor {
  // endpoints que no se cifran ni llevan token
  private readonly EXCLUDED = [
    '/auth/logout',
    '/auth/session-count',
    '/auth/user',
    '/config/actualizar-proveedor',
    '/config/carga-datos-iniciales',
    '/config/job/pagos'
  ];

  // endpoints que cifran params pero no llevan header (timestamp va dentro de data)
  private readonly LOGIN_PATHS = [
    '/auth/login',
    '/auth/resetpassword',
    '/users/registro'
  ];

  constructor(private crypto: CryptoService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // excluidos: pasan sin cambios
    if (this.isExcluded(req.url)) {
      return next.handle(req);
    }

    // login / reset password: cifrar params con timestamp dentro de data
    if (this.isLoginPath(req.url)) {
      return next.handle(this.handleLogin(req));
    }

    // multipart: solo agregar header X-Request-Token, params van normal
    if (req.body instanceof FormData) {
      const cloned = req.clone({
        setHeaders: { 'X-Request-Token': this.crypto.encryptTimestamp() }
      });
      return next.handle(cloned);
    }

    // request normal: cifrar params + agregar header
    return next.handle(this.handleNormal(req));
  }

  // método reutilizable para construir HttpParams con encoding correcto
  private buildEncryptedParams(encrypted: string): HttpParams {
    return new HttpParams({ encoder: new Base64Encoder() })
      .set('data', encrypted);
  }

  private handleLogin(req: HttpRequest<any>): HttpRequest<any> {
    // se obtienen los params actuales
    let queryString = '';
    req.params.keys().forEach((key, index) => {
      if (index > 0) queryString += '&';
      queryString += encodeURIComponent(key) + '=' + encodeURIComponent(req.params.get(key));
    });

    // se agrega timestamp (hora local, sin desfase porque aun no hay serverTime)
    queryString += '&timestamp=' + Date.now();
    
    // se cifra todo y se codifica
    const encrypted = this.crypto.encrypt(queryString);

    return req.clone({ params: this.buildEncryptedParams(encrypted) });
  }

  private handleNormal(req: HttpRequest<any>): HttpRequest<any> {
    // se cifran params si hay
    let clonedReq = req;

    if (req.params.keys().length > 0) {
      let queryString = '';
      req.params.keys().forEach((key, index) => {
        if (index > 0) queryString += '&';
        queryString += encodeURIComponent(key) + '=' + encodeURIComponent(req.params.get(key));
      });
      
      const encrypted = this.crypto.encrypt(queryString);

      clonedReq = req.clone({ params: this.buildEncryptedParams(encrypted) });
    }

    // se agrega header con timestamp cifrado
    return clonedReq.clone({
      setHeaders: { 'X-Request-Token': this.crypto.encryptTimestamp() }
    });
  }

  private isExcluded(url: string): boolean {
    return this.EXCLUDED.some(path => url.includes(path));
  }

  private isLoginPath(url: string): boolean {
    return this.LOGIN_PATHS.some(path => url.includes(path));
  }

}


// WEBPACK FOOTER //
// ./src/app/security/crypto.interceptor.ts